import React, { useState, useEffect } from "react";
import axios from "axios";
import { LuPackageSearch } from "react-icons/lu";
import { IoSearch } from "react-icons/io5";
import { NODE_BACKEND_API_URL } from "../../config";

function StickerSelection({ selectedStickerIdx, onStickerData }) {
    const [formData, setFormData] = useState({
        brandId: "",
        searchTerm: "", // Renamed state variable
    });

    const [brandOptions, setBrandOptions] = useState([
        { value: "", label: "Cargando Marcas...", disabled: true, hidden: true }
    ]);
    const [loadingBrands, setLoadingBrands] = useState(true);
    const [brandError, setBrandError] = useState(null);

    const [productOptions, setProductOptions] = useState([]);
    const [loadingProducts, setLoadingProducts] = useState(false);
    const [productError, setProductError] = useState(null);

    const [searchResults, setSearchResults] = useState([]);
    const [searchAttempted, setSearchAttempted] = useState(false);

    const brandQuantitiesUrl = `${NODE_BACKEND_API_URL}/getallbrands`;

    useEffect(() => {
        axios.get(brandQuantitiesUrl)
            .then(res => {
                const fetchedBrands = res.data.map(brand => ({
                    value: brand.BrandId,
                    label: brand.BrandName,
                }));
                setBrandOptions([
                    { value: "", label: "Seleccionar Marca", disabled: true, hidden: true },
                    ...fetchedBrands
                ]);
                setLoadingBrands(false);
            })
            .catch(er => {
                setBrandError("Error al cargar la lista de marcas.");
                setLoadingBrands(false);
                setBrandOptions([
                    { value: "", label: "Error cargando Marcas", disabled: true, hidden: true }
                ]);
            });
    }, [brandQuantitiesUrl]);

    function handleInputChange(e) {
        const { id, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [id]: value
        }));
        setSearchResults([]);
        setSearchAttempted(false);
        setProductError(null);
    }

    function handleBrandChange(e) {
        setFormData(prev => ({
            ...prev,
            brandId: e.target.value,
            searchTerm: "" // Reset searchTerm on brand change
        }));
        setSearchResults([]);
        setSearchAttempted(false);
        setProductError(null);
    }

    function handleProductSearch(e) {
        e.preventDefault();
        // Check for searchTerm instead of productCode
        if (!formData.brandId || !formData.searchTerm) {
            setProductError("Debe seleccionar una marca y escribir un término de búsqueda.");
            setSearchResults([]);
            setSearchAttempted(true);
            return;
        }
        setLoadingProducts(true);
        setProductError(null);
        axios.get(`${NODE_BACKEND_API_URL}/getbrandproducts`, {
            // Send searchTerm in the params
            params: { brandId: formData.brandId, searchTerm: formData.searchTerm }
        })
            .then(res => {
                const products = res.data || [];
                setSearchResults(products);
                setSearchAttempted(true);
                if (products.length === 1) {
                    setFormData(prev => ({ ...prev, searchTerm: products[0].ProductCode }));
                }
            })
            .catch(er => {
                setProductError("Error al buscar el producto.");
                setSearchResults([]);
                setSearchAttempted(true);
            })
            .finally(() => setLoadingProducts(false));
    }

    function handleSelectProduct(product) {
        setFormData(prev => ({ ...prev, searchTerm: product.ProductCode }));
        setSearchResults([product]);
    }

    async function handleSubmit(e) {
        e.preventDefault();
        if (!formData.brandId) {
            alert("Por favor, seleccione una marca.");
            return;
        }
        // Check for searchTerm instead of productCode
        if (!formData.searchTerm) {
            alert("Por favor, ingrese un término de búsqueda.");
            return;
        }
        const selectedProduct = searchResults.find(
            (product) => product.ProductCode === formData.searchTerm
        );
        if (!selectedProduct) {
            alert("Debe buscar y seleccionar un producto válido.");
            return;
        }

        let ean = selectedProduct.EAN;
        if (!ean) {
            try {
                const authToken = localStorage.getItem('authToken');
                if (!authToken) {
                    alert('No se encontró el token de autenticación. Por favor, inicie sesión de nuevo.');
                    return;
                }
                const response = await axios.post(
                    `${NODE_BACKEND_API_URL}/generateEANLabel`,
                    { 
                        brandId: formData.brandId,
                        productId: selectedProduct.ProductId // <-- Add this line
                    },
                    { headers: { 'Content-Type': 'application/json' } }
                );
                ean = response.data.ean;
            } catch (err) {
                alert('Error al generar EAN. Inténtelo de nuevo.');
                return;
            }
        }

        // Find the BrandName from brandOptions
        const brandObj = brandOptions.find(b => b.value === formData.brandId);
        const brandName = brandObj ? brandObj.label : "";

        const arranged = {
            BrandName: brandName, // Pass BrandName instead of BrandId
            ProductCode: selectedProduct.ProductCode, // Use selected product's data
            ProductDescription: selectedProduct.ProductDescription,
            EAN: ean
        };

        // Call the parent's handler to update the sticker
        if (typeof onStickerData === "function" && selectedStickerIdx != null) {
            onStickerData(selectedStickerIdx - 1, arranged); // -1 because stickers is 0-based
        }
    }

    const selectedProduct = searchResults.find(
        (product) => product.ProductCode === formData.searchTerm
    );

    const isDisabled = loadingBrands || brandError || selectedStickerIdx == null;

    return (
        <div className="editor-position" style={{ position: 'sticky', top: '10px', zIndex: 10 }}>
            <LuPackageSearch size={42} />
            <h2>
                {selectedStickerIdx != null
                    ? <>ETIQUETA: {selectedStickerIdx} - ELEGIR PRODUCTO</>
                    : <>ELEGIR ETIQUETA</>
                }
            </h2>
            <div
                className="variable-editor-div"
                style={{
                    opacity: isDisabled ? 0.5 : 1,
                    pointerEvents: isDisabled ? 'none' : 'auto',
                    filter: isDisabled ? 'grayscale(0.7)' : 'none'
                }}
            >
                {loadingBrands && (
                    <p>Cargando lista de marcas...</p>
                )}
                {brandError && (
                    <p style={{ color: "red" }}>{brandError}</p>
                )}
                <form className="editor-form" id="form" onSubmit={handleProductSearch}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
                        <label className="editor-label" htmlFor="brandId" style={{ marginRight: '0.5rem', minWidth: '100px' }}>Marca: </label>
                        <select
                            className="editor-input"
                            required
                            onChange={handleBrandChange}
                            id="brandId"
                            value={formData.brandId}
                            style={{ flexGrow: 1 }}
                        >
                            {brandOptions.map(option => (
                                <option
                                    key={option.value || 'select-brand'}
                                    value={option.value}
                                    disabled={option.disabled || false}
                                    hidden={option.hidden || false}
                                >
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
                        <label className="editor-label" htmlFor="searchTerm" style={{ marginRight: '0.5rem', minWidth: '100px' }}>Producto: </label>
                        <div style={{ display: 'flex', flexGrow: 1 }}>
                            <input
                                className="editor-input"
                                id="searchTerm" // Changed ID
                                type="text"
                                value={formData.searchTerm}
                                onChange={handleInputChange}
                                style={{ flexGrow: 1, marginRight: 4 }}
                                disabled={!formData.brandId || loadingProducts}
                                placeholder="Código o Descripción" // Updated placeholder
                            />
                            <button
                                type="submit"
                                disabled={!formData.brandId || !formData.searchTerm || loadingProducts}
                                style={{
                                    border: '1px solid #385e96',
                                    background: '#f0f4fa',
                                    color: '#385e96',
                                    borderRadius: '4px',
                                    padding: '0 12px',
                                    height: '32px',
                                    cursor: 'pointer'
                                }}
                                title="Buscar producto"
                            >
                                <IoSearch />
                            </button>
                        </div>
                    </div>
                </form>
                {loadingProducts && (
                    <div style={{ marginBottom: '1rem', color: '#888' }}>Buscando producto...</div>
                )}
                {productError && (
                    <div style={{ marginBottom: '1rem', color: 'red' }}>{productError}</div>
                )}
                {/* Show results if search was attempted */}
                {searchAttempted && searchResults.length > 1 && (
                    <div style={{ marginBottom: '1rem' }}>
                        <div style={{ fontWeight: 500, marginBottom: 4 }}>Seleccione un producto:</div>
                        {searchResults.map(product => (
                            <div
                                key={product.ProductId}
                                onClick={() => handleSelectProduct(product)}
                                style={{
                                    cursor: 'pointer',
                                    padding: '6px 10px',
                                    borderRadius: '6px',
                                    background: product.ProductCode === formData.searchTerm ? '#f0dc8d' : '#f7f7f7',
                                    border: product.ProductCode === formData.searchTerm ? '2px solid #385e96' : '1px solid #ccc',
                                    marginBottom: 4,
                                    color: '#222'
                                }}
                            >
                                <strong>{product.ProductCode}</strong> - {product.ProductDescription} ({product.EAN})
                            </div>
                        ))}
                    </div>
                )}
                {/* Show description if only one result or one is selected */}
                {selectedProduct && (
                    <div style={{ marginBottom: '1rem', color: '#385e96', fontWeight: 500 }}>
                        Descripción: {selectedProduct.ProductDescription}
                    </div>
                )}
                <div style={{ textAlign: 'center' }}>
                    <button className="submit-btn-blue" id="sbm" type="button" onClick={handleSubmit} disabled={!selectedProduct}>
                        <span id="button__text">GENERAR ETIQUETA CON CÓDIGO DE BARRAS</span>
                    </button>
                </div>
            </div>
        </div>
    );
}

export default StickerSelection;